import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import Icon from './icon.gjs';
import LoadingIndicator from './loading-indicator.gjs';
import { faXmark, faArrowLeft } from '../icons/solid.js';

<template>
  <div class="flex items-center space-x-3 pl-2 pr-1 mb-3">
    {{#if @onBack}}
      <button
        class="btn btn-square btn-ghost tooltip tooltip-right"
        data-tip={{t "back"}}
        {{on "click" @onBack}}
      >
        <Icon @icon={{faArrowLeft}} @size="xl" />
      </button>
    {{/if}}

    <Icon @icon={{@icon}} @size="xl" @class="text-accent" />

    <div>
      <div class="text-xl">
        <span class="font-semibold">{{@title}}</span>
        {{#if @subtitle}}| {{@subtitle}}{{/if}}
      </div>
      <div class="text-sm">{{@description}}</div>
    </div>

    <LoadingIndicator @promise={{@promise}} />

    <div class="flex-1" />

    {{#if @onClose}}
      <button
        class="btn btn-square btn-ghost tooltip tooltip-left"
        data-tip={{t "close"}}
        {{on "click" @onClose}}
      >
        <Icon @icon={{faXmark}} />
      </button>
    {{/if}}
  </div>
</template>
